export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/a92d826d80900dda6092d3b109ffaee1.svg";